module.exports = __webpack_public_path__ + "img/logo2.d2bc53c8.png";